/**
 * OverlaySuperLowerThird - Horse info lower third with blue/gold broadcast theme
 */

import { TravparkLogo } from './TravparkLogo';

const formatShoeInfo = (frontShoes, backShoes) => {
  if (frontShoes && backShoes) return 'CC';
  if (!frontShoes && backShoes) return 'C';
  if (frontShoes && !backShoes) return 'F';
  if (!frontShoes && !backShoes) return 'ub';
  return null;
};

export function OverlaySuperLowerThird({
  superVisible, showSuper, superHorse, colors, sommertravetMode
}) {
  if (!superVisible) return null;

  return (
    <div
      data-testid="lower-third"
      className={showSuper && superHorse ? 'broadcast-slide-up' : 'broadcast-slide-up-out'}
      style={{
        position: 'absolute',
        bottom: '85px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        border: '2px solid var(--theme-panel-border-subtle)',
        borderRadius: '12px 12px 0 0',
        backgroundColor: '#050F23',
        padding: '0',
        minWidth: '500px',
        maxWidth: '700px',
        boxShadow: `0 0 30px rgba(var(--theme-accent-rgb), 0.15), 0 15px 45px rgba(0,0,0,0.5)`,
        overflow: 'hidden',
        zIndex: 1,
        isolation: 'isolate',
      }}
    >

      {superHorse && (
        <div style={{ position: 'relative', zIndex: 1 }}>
          {/* Header with horse number */}
          <div style={{
            background: 'linear-gradient(135deg, var(--theme-header-gradient) 0%, transparent 100%)',
            borderBottom: '2px solid var(--theme-panel-border)',
            color: '#FFFFFF',
            padding: '16px 24px', display: 'flex', alignItems: 'center', gap: '16px',
          }}>
            <div style={{
              width: '56px', height: '56px', backgroundColor: 'var(--theme-accent)', color: '#0A1628',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontFamily: "'JetBrains Mono', monospace", fontWeight: 700, fontSize: '2rem', borderRadius: '8px'
            }}>
              {superHorse.number}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '2rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.02em', color: '#FFFFFF' }}>
                {superHorse.name}
              </div>
              <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '1.25rem', color: 'rgba(255,255,255,0.6)', marginTop: '2px' }}>
                {superHorse.driver}
              </div>
            </div>
            <TravparkLogo height={32} sommertravetMode={sommertravetMode} style={{ flexShrink: 0, marginRight: '12px' }} />
            {formatShoeInfo(superHorse.front_shoes, superHorse.back_shoes) && (
              <div style={{
                backgroundColor: 'var(--theme-panel-border-subtle)', color: 'var(--theme-accent)',
                border: '1px solid var(--theme-panel-border-subtle)',
                padding: '6px 12px', borderRadius: '6px',
                fontFamily: "'JetBrains Mono', monospace", fontWeight: 700, fontSize: '1rem', textTransform: 'uppercase'
              }}>
                {formatShoeInfo(superHorse.front_shoes, superHorse.back_shoes)}
              </div>
            )}
          </div>

          {/* Stats row */}
          <div style={{ display: 'flex', padding: '16px 24px', gap: '32px', background: 'rgba(255,255,255,0.03)' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '2rem', fontWeight: 700, color: '#FFFFFF' }}>
                {superHorse.odds > 0 ? superHorse.odds.toFixed(2) : '-'}
              </div>
              <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '0.9rem', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase' }}>V-Odds</div>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '1.7rem', fontWeight: 600, color: 'var(--theme-accent)' }}>
                  {superHorse.distribution?.toFixed(1)}%
                </div>
                <div style={{ flex: 1, height: '12px', backgroundColor: 'rgba(var(--theme-accent-rgb), 0.15)', borderRadius: '6px', overflow: 'hidden' }}>
                  <div style={{ width: `${Math.min(superHorse.distribution || 0, 100)}%`, height: '100%', backgroundColor: 'var(--theme-accent)', borderRadius: '6px' }} />
                </div>
              </div>
              <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '0.9rem', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', marginTop: '4px' }}>Spillerandel</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '1.7rem', fontWeight: 600, color: '#FFFFFF' }}>
                {superHorse.trend > 0 ? '+' : ''}{((superHorse.trend || 0) * 100).toFixed(1)}%
              </div>
              <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '0.9rem', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase' }}>Trend</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
